import React, { useEffect } from "react";
import { project } from "../Data/data.js";
const ShowModal = ({ closeModal, arrayNum }) => {
  useEffect(() => {
    document.body.style.overflowY = "hidden";

    return () => {
      document.body.style.overflowY = "scroll";
    };
  }, []);

  return (
    <>
      <div
        className="fixed top-0 left-0 right-0 bottom-0 bg-blue-100 opacity-[0.8]"
        onClick={closeModal}
      ></div>
      <div className="fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] h-auto w-[80vw] md:w-[50vw] bg-blue-400 rounded-md shadow-lg shadow-blue-400">
        <div className=" text-center py-4 px-2 md:px-8">
          <h1 className="text-lg sm:text-3xl md:text-2xl">
            {project[arrayNum - 1].name}
          </h1>
          <div className="h-1 w-[20vw] bg-black translate-x-[10vw] lg:translate-x-[12vw] mb-4 hidden md:block" />
          <div className="flex justify-center items-center">
            <img
              src={project[arrayNum - 1].image}
              alt=""
              className="lg:h-48 h-32 w-44 xl:w-80 lg:w-72 my-4 z-[100] md:block hidden"
            />
            <p className="flex justify-center items-center pl-2 text-blue-100 font-semibold text-sm pt-4 sm:text-base tracking-wide">
              {project[arrayNum - 1].desc}
            </p>
          </div>
          <button
            className="bg-white p-1 mt-4 shadow-sm shadow-blue-700 rounded-lg px-4 hover:-translate-y-[0.1rem] duration-[0.5s] hover:shadow-lg border-2 border-blue-300 hover:border-transparent"
            onClick={closeModal}
          >
            !close
          </button>
        </div>
      </div>
    </>
  );
};

export default ShowModal;
